import { getFromSession } from "../../../__utilities/functions/sessionHandler.js";

// Uncomment console logs for testing purposes of requestId.

let currentRequestId = getFromSession("request_id");

export const setRequestId = (requestId) => {
  currentRequestId = requestId;
  // console.log("Request ID set to:", currentRequestId);
};

export const getRequestId = () => {
  // console.log("Retrieved Request ID:", currentRequestId);
  return currentRequestId;
};

export const clearRequestId = () => {
  currentRequestId = null;
  // console.log("Request ID cleared");
};
